import { Ciap, Procedimento } from 'graphql/types.generated'

import { extractFromFiltro } from '../utils-HistoricoDwCiapFiltro'
import { CiapProcedimento } from './HistoricoCiapProcedimento'

export const convertToCiapsProcedimentos = (
  filtro: string | null | undefined,
  ciaps: Ciap[],
  procedimentos?: Procedimento[] | null
) =>
  [
    ...extractFromFiltro(filtro).map((codigo) => {
      const ciap = ciaps.find((ciap) => ciap.codigo === codigo)
      if (ciap !== undefined && ciap !== null) return ciapToCiapProcedimento(ciap)
      return null
    }),
    ...(procedimentos || []).map((procedimento) => {
      return procedimentoToCiapProcedimento(procedimento)
    }),
  ]
    .filter((item): item is CiapProcedimento => item !== null)
    ?.toSorted((a, b) => a.descricao.localeCompare(b.descricao))

const ciapToCiapProcedimento = (ciap: Ciap): CiapProcedimento => ({
  codigo: ciap.codigo,
  descricao: ciap.descricao,
  tipo: 'CIAP',
})

const procedimentoToCiapProcedimento = (procedimento: Procedimento): CiapProcedimento => ({
  codigo: procedimento.codigo,
  descricao: procedimento.descricao,
  tipo: 'SISAB',
})
